// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".create-channel-dialog.common-dialog[data-v-60f7c556] .el-dialog{width:var(--common-dialog-medium-width)}.create-channel-dialog.common-dialog .el-form[data-v-60f7c556]{margin-right:var(--common-dialog-form-margin-right)}.create-channel-dialog.common-dialog .el-select[data-v-60f7c556]{width:100%}", ""]);
// Exports
module.exports = exports;
